import { defineComponent as _defineComponent } from 'vue'
import { computed, useStore } from "@nuxtjs/composition-api";

import { useLinkService } from "@/composables";
import { getLtksStore } from "@/store/ltks";


export default /*#__PURE__*/_defineComponent({
  __name: 'LtkShare',
  props: {
  ltkId: { type: String, required: true },
  isRunway: { type: Boolean, required: false, default: false },
},
  setup(__props) {

const props = __props;



const store = useStore();
const linkService = useLinkService();

const ltk = computed(() => getLtksStore(store).ltks[props.ltkId]);
const ltkShareUrl = computed(() => ltk.value?.shareUrl || "");
const ltkCaption = computed(() => ltk.value?.caption || "");

const heroImageUrl = computed(() => {
  return linkService.getImageLink({
    url: ltk.value?.heroImage ?? "",
    width: "405",
    useDefaultDpr: false,
  });
});

return { __sfc: true,props, store, linkService, ltk, ltkShareUrl, ltkCaption, heroImageUrl }
}

})